import axios from "axios";

const getKey = () => axios.get(`/personal/api/v1/totp/key`);

const initKey = () => axios.put(`/personal/api/v1/totp/init`);

const getQr = () => axios.get(("/personal/api/v1/totp/qr"+ "?random=" + new Date().getTime()), {responseType: 'arraybuffer'});

const verifyPass = (pass) => axios.put(`/personal/api/v1/totp/verify`, { passcode: pass });

export default {
    getKey,
    initKey,
    getQr,
    verifyPass
}